import styles from "./PPTPollsPage.module.css";
import {
    JOIN_ENGAGE_ATTENDANCE,
    JOIN_ENGAGE_POLL,
    POLL_TYPE,
    PPT_INSTRUCTION_SLIDE_STEP_1_ATTENDANCE,
    PPT_INSTRUCTION_SLIDE_STEP_1_POLL,
    PPT_INSTRUCTION_SLIDE_STEP_2_ATTENDANCE,
    PPT_INSTRUCTION_SLIDE_STEP_2_POLL,
    PPT_INSTRUCTION_SLIDE_STEP_3,
    PPT_INSTRUCTION_SLIDE_STEP_INTRODUCTION,
} from "../../utils/constants";

import {getShortName, } from "../../utils/helpers";
import React, {useEffect, useState} from "react";
import {QRCodeCanvas} from "qrcode.react";
import {useParams} from "react-router-dom";
import {ReactComponent as LOGO_ICON} from "../../images/yujalogo.svg"
import {PollApiCalls} from "../../apis/PollApiCalls";
import Skeleton from "react-loading-skeleton";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {useConfig} from "../../hooks/useConfig";



export default function SlideInstructionTemplate({ }) {
    const {getPublishedPollDataFromKey, } = PollApiCalls();
    const {getRedirectUrl, canHavePollCode} = useSynLMSConfiguration();
    const config = useConfig();

    let {pollKey, pollCode} = useParams();
    let shortName = getShortName();
    const HOST = shortName + '.' + config.host_url;
    const [dataReady, setDataReady] = useState(false);
    const [poll, setPoll] = useState({});

    useEffect(() => {
       getPublishedPollDataFromKey(pollKey, pollCode).then(res => {
            let {poll= {}} = res;
           setPoll(poll);
        }).finally(() => {
           setDataReady(true);
       });

    }, []);

    if (!dataReady) {
        return (
            <div className={`${styles.canvas}`}>
                <Skeleton borderRadius={10} inline={true} width={"100%"} height={"100%"}/>
            </div>
        );
    }


    let redirectUrl = getRedirectUrl(poll);
    let isPollCodeVisible = canHavePollCode(poll);

    const renderLeftPortion = () => {
        return (
            <div
                className={`${styles.canvasLeftPart} ${styles.column}`}
                style={{height: "100%", alignItems: "center", position: "relative"}}
            >
                <div style={{flex: 1}}/>
                {!!redirectUrl &&
                    <>
                        <span
                            style={{fontSize: 18, fontWeight: "700", maxWidth: "100%", textAlign: "center"}}
                        >{poll.pollTitle}</span>
                        {isPollCodeVisible &&
                            <>
                                <span className={styles.canvasJoinText}>{`Join at ${HOST}`}</span>
                                <span className={styles.pollCodeBadge}>{"Use Code: " + pollCode}</span>
                            </>
                        }


                        <div className={styles.QRCodeWrapper} style={{marginTop: 25}}>
                            <QRCodeCanvas
                                id={`QR${pollCode}`}
                                size={130}
                                renderAs="canvas"
                                value={redirectUrl}
                            />
                        </div>
                    </>
                }

                {!redirectUrl &&
                    <span style={{fontSize: 25, fontWeight: "700", maxWidth: "100%", textAlign: "center"}}>
                        {poll.pollTitle}
                    </span>
                }

                <div style={{flex: 1}}/>
            </div>
        );
    }


    return (
        <div>
            <div className={`${styles.canvas} ${styles.row}`} data-yuja-slide={`instruction`}>
                {/*left portion*/}
                {renderLeftPortion()}

                {/*right portion*/}
                <div className={styles.column}
                     style={{flex: 1, minWidth: 0, height: "100%", padding: 90, alignItems: "center"}}>
                    <span
                        className={`${styles.poweredYuJaText} ${styles.row}`}
                        style={{gap: 7, width: 'fit-content'}}
                    >
                        <LOGO_ICON style={{width: 22, height: 22}}/>
                        {"Powered by YuJa"}
                    </span>

                    <span className={styles.canvasTitle} style={{marginTop: 9}}>
                       {poll.pollType === POLL_TYPE.ATTENDANCE
                           ? JOIN_ENGAGE_ATTENDANCE
                           : JOIN_ENGAGE_POLL
                       }
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 60}}>
                        {PPT_INSTRUCTION_SLIDE_STEP_INTRODUCTION}
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 40}}>
                        {poll.pollType === POLL_TYPE.ATTENDANCE
                            ? PPT_INSTRUCTION_SLIDE_STEP_1_ATTENDANCE
                            : PPT_INSTRUCTION_SLIDE_STEP_1_POLL
                        }
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 30}}>
                         {poll.pollType === POLL_TYPE.ATTENDANCE
                             ? PPT_INSTRUCTION_SLIDE_STEP_2_ATTENDANCE
                             : PPT_INSTRUCTION_SLIDE_STEP_2_POLL
                         }
                    </span>

                    <span className={styles.canvasStepsText} style={{marginTop: 30}}>
                        {PPT_INSTRUCTION_SLIDE_STEP_3}
                    </span>
                </div>
            </div>
        </div>

    );
}